export var devApiConstants = {
  UAT_AUTH_CLIENTID: 'YYYYYYN',
  OCP_UAT: 'ocp2-uat.beelinetst.ru',
  OCP_UAT_ENV: '302eccb3-6d67-498e-8c02-3483f0e6990b',
  LOCAL_PROXY_PORT: 3000
};
export var MobileConnectionType = /*#__PURE__*/function (MobileConnectionType) {
  MobileConnectionType[MobileConnectionType["Unknown"] = 0] = "Unknown";
  MobileConnectionType[MobileConnectionType["Wifi"] = 1] = "Wifi";
  MobileConnectionType[MobileConnectionType["M_2G"] = 2] = "M_2G";
  MobileConnectionType[MobileConnectionType["M_2G_EDGE"] = 3] = "M_2G_EDGE";
  MobileConnectionType[MobileConnectionType["M_2G_GPRS"] = 4] = "M_2G_GPRS";
  MobileConnectionType[MobileConnectionType["M_3G"] = 5] = "M_3G";
  MobileConnectionType[MobileConnectionType["M_3G_HSUPA"] = 6] = "M_3G_HSUPA";
  MobileConnectionType[MobileConnectionType["M_3G_HSDPA"] = 7] = "M_3G_HSDPA";
  MobileConnectionType[MobileConnectionType["M_LTE"] = 8] = "M_LTE";
  MobileConnectionType[MobileConnectionType["M_5G"] = 9] = "M_5G";
  return MobileConnectionType;
}({});
export var DesktopOsType = /*#__PURE__*/function (DesktopOsType) {
  DesktopOsType["Macos"] = "Macos";
  DesktopOsType["Windows"] = "Windows";
  DesktopOsType["Linux"] = "Linux";
  return DesktopOsType;
}({});
export var isDev = process.env.NODE_ENV === 'development';
export var protocol = {
  http: isDev ? 'http' : 'https',
  websocket: isDev ? 'ws' : 'wss'
};
export var localhost = "localhost:".concat(devApiConstants.LOCAL_PROXY_PORT);
export var LIMIT_LAST_SESSION_UPDATE = 10;
export var HELLO_TEXT = 'здравствуйте';
export var END_TEXT = 'Спасибо за обращение!';
export var REFRESH_TEXT = 'не удалось<br/>загрузить фото';
export var DEFAULT_CHARS_LIMIT = 6000;
export var DEFAULT_AUTH_ZONE_CFG = {
  zoneType: 'unauthorized',
  showMessageBeforeInput: true
};
export var DEFAULT_BROWSER_NOTIFICATION = 'Новый ответ в чате поддержки';
export var ErrorScreenType = /*#__PURE__*/function (ErrorScreenType) {
  ErrorScreenType["LOAD"] = "LOAD";
  ErrorScreenType["ERROR"] = "ERROR";
  ErrorScreenType["OFFLINE"] = "OFFLINE";
  ErrorScreenType["BLOCK"] = "BLOCK";
  ErrorScreenType["UNKNOWN"] = "UNKNOWN";
  return ErrorScreenType;
}({});
export var ErrorReason = /*#__PURE__*/function (ErrorReason) {
  ErrorReason["HISTORY_LOAD"] = "HISTORY_LOAD";
  ErrorReason["CONTENT_LOAD"] = "CONTENT_LOAD";
  ErrorReason["VALIDATE_CAPTCHA"] = "VALIDATE_CAPTCHA";
  ErrorReason["OFFLINE"] = "OFFLINE";
  ErrorReason["REFRESH_TOKEN"] = "REFRESH_TOKEN";
  ErrorReason["WEBSOCKET_CONNECTION"] = "WEBSOCKET_CONNECTION";
  ErrorReason["UNKNOWN"] = "UNKNOWN";
  return ErrorReason;
}({});